export const PLAYFAIR_40PX_SEMIBOLD =
    " text-2xl md:text-4xl !font-semibold  font-Montserrat text-Heading_Black text-center ";
